import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { HOME_SLICE_NAME as SLICE_NAME } from "./home.constants"

// The Health endpoints are gated to Owner/Administrator (`HasUserManagementRole`), so a 403 is an
// expected answer for the other roles, not a failure worth the global error notification.
const rejectHealthResponse = async (dispatch, response, rejectWithValue) => {
  if (response.status === 403) return rejectWithValue({ forbidden: true })
  await handleApiError(dispatch, response)
  return rejectWithValue(response.data)
}

export const getHomeMainInfo = createAsyncThunk(
  `${SLICE_NAME}/get_main_info`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomeMainInfo(params)
    if (!response.ok) return rejectHealthResponse(dispatch, response, rejectWithValue)
    return response.data
  }
)

export const getHomeRateChart = createAsyncThunk(
  `${SLICE_NAME}/get_rate_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomeRateChart(params)
    if (!response.ok) return rejectHealthResponse(dispatch, response, rejectWithValue)
    return response.data
  }
)

export const getHomePreventedChart = createAsyncThunk(
  `${SLICE_NAME}/get_prevented_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomePreventedChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getHomeDeflectedChart = createAsyncThunk(
  `${SLICE_NAME}/get_deflected_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomeDeflectedChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getHomeKpiCards = createAsyncThunk(
  `${SLICE_NAME}/get_kpi_cards`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomeKpiCards(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getHomeActionAlerts = createAsyncThunk(
  `${SLICE_NAME}/get_action_alerts`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHomeActionAlerts(params)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
